"use client";

import { useState } from "react";
import styles from "./FAQ.module.scss";
import LeadFormWrapperNew from "@/revamp/sections/HomeNewFaq/LeadFormNew";

const FAQ = ({ Faqs ,associatedPrograms}: any) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        {/* FAQ Card */}
        <div className={styles.faqCard}>
          <h2 className={styles.faqTitle}>Frequently Asked Questions</h2>
          <div className={styles.accordionList}>
            {Faqs?.FAQitems?.map((faq: any, i: number) => (
              <div key={i} className={styles.accordionItem}>
                <button
                  type="button"
                  className={styles.accordionQuestion}
                  onClick={() => toggle(i)}
                >
                  <span>{faq?.question}</span>
                  <span
                    className={`${styles.toggleIcon} ${
                      openIndex === i ? styles.toggleIconOpen : ""
                    }`}
                  />
                </button>
                {openIndex === i && (
                  <div className={styles.accordionAnswer}>
                    <p dangerouslySetInnerHTML={{ __html: faq?.answer }}></p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.leadFormWrapper}>
          <LeadFormWrapperNew associatedPrograms={associatedPrograms}/>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
